import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Checkbox,
  Label,
  Button,
  Dropdown
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardReserveTransferQueueUX = (props: any) => {
    return(
      <div>
        <div
          className="accordion ui fluid blue raised segment"
          id="CardReserveTransferQueueUX-div-1"
          style={{boxShadow: "none"}}>
          
          <div
            id="CardReserveTransferQueueUX-div-52"
            style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
            
            <label
              id="CardReserveTransferQueueUX-label-53"
              style={{fontSize: "1.25rem", fontWeight: "bold"}}>
              {props.languageUX === "en" ? "Ward transfer queue" : "คิวย้าย Ward"}
            </label>
            <div
              id="CardReserveTransferQueueUX-div-54"
              style={{display: "flex", alignItems: "center"}}>
              
            </div>
          </div>
          <div
            className="ui divider"
            id="CardReserveTransferQueueUX-div-3">
            
          </div>
          <div
            className="ui form small"
            id="CardReserveTransferQueueUX-div-4">
            
            <FormGroup
              id="CardReserveTransferQueueUX-FormGroup-5"
              inline={true}>
              <FormField
                id="CardReserveTransferQueueUX-FormField-6"
                inline={true}
                width={2}>
                <Checkbox
                  checked={props.isHN}
                  id="CardReserveTransferQueueUX-Checkbox-10"
                  label={props.languageUX === "en" ? "HN" : "HN"}
                  name="isHN"
                  onChange={props.onChangeValue}>
                </Checkbox>
              </FormField>
              <FormField
                id="CardReserveTransferQueueUX-FormField-7"
                inline={true}
                width={2}>
                <div
                  id="CardReserveTransferQueueUX-div-11"
                  style={{width: "100%"}}>
                  {props.PatientSearchBox}
                </div>
              </FormField>
              <FormField
                id="CardReserveTransferQueueUX-FormField-8"
                inline={true}
                width={4}>
                <Label
                  className="large fluid"
                  id="CardReserveTransferQueueUX-Label-12">
                  {props.patientFullName || "-"}
                </Label>
              </FormField>
              <FormField
                id="CardReserveTransferQueueUX-FormField-13"
                inline={true}
                width={1}>
              </FormField>
              <FormField
                id="CardReserveTransferQueueUX-FormField-14"
                inline={true}
                width={3}>
                <Checkbox
                  checked={props.isTransferDate}
                  id="CardReserveTransferQueueUX-Checkbox-15"
                  label={props.languageUX === "en" ? "Date range want to move" : "ช่วงวันที่ต้องการย้าย"}
                  name="isTransferDate"
                  onChange={props.onChangeValue}>
                </Checkbox>
              </FormField>
              <FormField
                id="CardReserveTransferQueueUX-FormField-16"
                inline={true}
                width={2}>
                <div
                  id="CardReserveTransferQueueUX-div-17"
                  style={{width: "100%"}}>
                  {props.TransferStartDate}
                </div>
              </FormField>
              <FormField
                id="CardReserveTransferQueueUX-FormField-18"
                inline={true}
                width={2}>
                <div
                  id="CardReserveTransferQueueUX-div-19"
                  style={{width: "100%"}}>
                  {props.TransferEndDate}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardReserveTransferQueueUX-FormGroup-20"
              inline={true}>
              <FormField
                id="CardReserveTransferQueueUX-FormField-21"
                inline={true}
                width={2}>
                <Checkbox
                  checked={props.isTransferStatus}
                  id="CardReserveTransferQueueUX-Checkbox-28"
                  label={props.languageUX === "en" ? "Move status" : "สถานะการย้าย"}
                  name="isTransferStatus"
                  onChange={props.onChangeValue}>
                </Checkbox>
              </FormField>
              <FormField
                id="CardReserveTransferQueueUX-FormField-22"
                inline={true}
                width={6}>
                <Dropdown
                  id="CardReserveTransferQueueUX-Dropdown-57"
                  name="transferStatus"
                  onChange={props.onChangeValue}
                  options={props.transferStatusOptions || []}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.transferStatus || ""}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardReserveTransferQueueUX-FormField-24"
                inline={true}
                width={1}>
              </FormField>
              <FormField
                id="CardReserveTransferQueueUX-FormField-25"
                inline={true}
                width={3}>
                <Checkbox
                  checked={props.isUrgency}
                  id="CardReserveTransferQueueUX-Checkbox-31"
                  label={props.languageUX === "en" ? "Urgency" : "ความเร่งด่วน"}
                  name="isUrgency"
                  onChange={props.onChangeValue}>
                </Checkbox>
              </FormField>
              <FormField
                id="CardReserveTransferQueueUX-FormField-26"
                inline={true}
                width={4}>
                <Dropdown
                  id="CardReserveTransferQueueUX-Dropdown-58"
                  name="urgency"
                  onChange={props.onChangeValue}
                  options={props.transferUrgencyOptions || []}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.urgency || ""}>
                </Dropdown>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardReserveTransferQueueUX-FormGroup-34"
              inline={true}>
              <FormField
                id="CardReserveTransferQueueUX-FormField-35"
                inline={true}
                width={15}>
              </FormField>
              <FormField
                id="CardReserveTransferQueueUX-FormField-40"
                inline={true}
                width={1}>
                <Button
                  className="fluid"
                  color={"green"}
                  icon={true}
                  id="CardReserveTransferQueueUX-Button-47"
                  onClick={props.onSearch}
                  size={"small"}>
                  {props.languageUX === "en" ? "search" : "ค้นหา"}
                </Button>
              </FormField>
            </FormGroup>
            <div
              id="CardReserveTransferQueueUX-div-50">
              
              <Table
                data={props.reserveTransferQueueList}
                getTrProps={props.getTrProps}
                headers="HN, ข้อมูลผู้ป่วย, ห้องปัจจุบัน,วันที่ต้องการย้าย,ประเภท,ความเร่งด่วน, สถานะการจอง"
                id="CardReserveTransferQueueUX-Table-51"
                keys="hn,patient_name,current_room_no,plan_transfer_date,division,urgency_name,status_label"
                showPagination={false}
                style={{height: "250px"}}>
              </Table>
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardReserveTransferQueueUX

export const screenPropsDefault = {"language":"TH"}

/* Date Time : Thu Nov 20 2025 07:17:11 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "accordion ui fluid blue raised segment"
        },
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{boxShadow: \"none\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-div-3"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form small"
        },
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-div-4"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormGroup",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-FormGroup-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-FormField-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-FormField-7"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-FormField-8"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "Checkbox",
      "parent": 6,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isHN"
        },
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-Checkbox-10"
        },
        "label": {
          "type": "value",
          "value": "HN",
          "valueEN": "HN"
        },
        "name": {
          "type": "value",
          "value": "isHN"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.PatientSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-div-11"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "Label",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientFullName || \"-\""
        },
        "className": {
          "type": "value",
          "value": "large fluid"
        },
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-Label-12"
        },
        "name": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-FormField-13"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-FormField-14"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "Checkbox",
      "parent": 14,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isTransferDate"
        },
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-Checkbox-15"
        },
        "label": {
          "type": "value",
          "value": "ช่วงวันที่ต้องการย้าย",
          "valueEN": "Date range want to move"
        },
        "name": {
          "type": "value",
          "value": "isTransferDate"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-FormField-16"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 16,
      "props": {
        "children": {
          "type": "code",
          "value": "props.TransferStartDate"
        },
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-div-17"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-FormField-18"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "code",
          "value": "props.TransferEndDate"
        },
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormGroup",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-FormGroup-20"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-FormField-21"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-FormField-22"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-FormField-24"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-FormField-25"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-FormField-26"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "Checkbox",
      "parent": 21,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isTransferStatus"
        },
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-Checkbox-28"
        },
        "label": {
          "type": "value",
          "value": "สถานะการย้าย",
          "valueEN": "Move status"
        },
        "name": {
          "type": "value",
          "value": "isTransferStatus"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "Checkbox",
      "parent": 25,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isUrgency"
        },
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-Checkbox-31"
        },
        "label": {
          "type": "value",
          "value": "ความเร่งด่วน",
          "valueEN": "Urgency"
        },
        "name": {
          "type": "value",
          "value": "isUrgency"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "FormGroup",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-FormGroup-34"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "FormField",
      "parent": 34,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-FormField-35"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "15"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "FormField",
      "parent": 34,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-FormField-40"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "Button",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "search"
        },
        "className": {
          "type": "value",
          "value": "fluid"
        },
        "color": {
          "type": "code",
          "value": "\"green\""
        },
        "icon": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-Button-47"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSearch"
        },
        "size": {
          "type": "code",
          "value": "\"small\""
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-div-50"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 51,
      "name": "Table",
      "parent": 50,
      "props": {
        "data": {
          "type": "code",
          "value": "props.reserveTransferQueueList"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.getTrProps"
        },
        "headers": {
          "type": "value",
          "value": "HN, ข้อมูลผู้ป่วย, ห้องปัจจุบัน,วันที่ต้องการย้าย,ประเภท,ความเร่งด่วน, สถานะการจอง"
        },
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-Table-51"
        },
        "keys": {
          "type": "value",
          "value": "hn,patient_name,current_room_no,plan_transfer_date,division,urgency_name,status_label"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"250px\"}"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-div-52"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "label",
      "parent": 52,
      "props": {
        "children": {
          "type": "value",
          "value": "คิวย้าย Ward",
          "valueEN": "Ward transfer queue"
        },
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-label-53"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.25rem\", fontWeight: \"bold\"}"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "div",
      "parent": 52,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-div-54"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "Dropdown",
      "parent": 22,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-Dropdown-57"
        },
        "name": {
          "type": "value",
          "value": "transferStatus"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.transferStatusOptions || []"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.transferStatus || \"\""
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "Dropdown",
      "parent": 26,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReserveTransferQueueUX-Dropdown-58"
        },
        "name": {
          "type": "value",
          "value": "urgency"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.transferUrgencyOptions || []"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.urgency || \"\""
        }
      },
      "seq": 58,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 70,
  "isMounted": false,
  "memo": false,
  "name": "CardReserveTransferQueueUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "TH"
  },
  "width": 65
}

*********************************************************************************** */
